<template>
  <div class="farm-query">
    <div class="card">
      <div class="bg-primary text-white card-header">
        <h5 class="mb-0">농가 위치 조회</h5>
      </div>
      <div class="card-body">
        <div class="input-group mb-3">
          <input
            v-model="frmhsNo"
            type="text"
            class="form-control form-control-lg"
            placeholder="농가번호 입력 (예: 00012278)"
            @keyup.enter="searchFarm"
          />
          <button class="btn btn-primary btn-lg" @click="searchFarm" @keyup.enter="searchFarm">
            조회
          </button>
        </div>

        <div v-if="error" class="alert alert-danger alert-dismissible fade show">
          {{ error }}
          <button type="button" class="btn-close" @click="error = ''"></button>
        </div>

        <div v-if="currentUrl" class="iframe-container">
          <iframe
            :src="currentUrl"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </div>

        <div v-else-if="!error" class="mt-5 text-muted text-center">
          <p>농가번호를 입력하고 조회 버튼을 눌러주세요</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'

const frmhsNo = ref('')
const currentUrl = ref('')
const error = ref('')

// 원래 manifest 링크 저장
let originalManifestHref = ''

onMounted(() => {
  // 현재 manifest 링크 찾기
  const manifestLink = document.querySelector('link[rel="manifest"]')

  if (manifestLink) {
    // 원래 manifest href 저장
    originalManifestHref = manifestLink.getAttribute('href') || ''

    // Farm 페이지 전용 manifest로 변경
    manifestLink.setAttribute('href', '/manifest-farm.json')
  } else {
    // manifest 링크가 없으면 새로 생성
    const newLink = document.createElement('link')
    newLink.rel = 'manifest'
    newLink.href = '/manifest-farm.json'
    document.head.appendChild(newLink)
  }
})

onUnmounted(() => {
  // 페이지를 벗어날 때 원래 manifest로 복원
  const manifestLink = document.querySelector('link[rel="manifest"]')

  if (manifestLink && originalManifestHref) {
    manifestLink.setAttribute('href', originalManifestHref)
  }
})

function searchFarm() {
  error.value = ''

  if (!frmhsNo.value.trim()) {
    error.value = '농가번호를 입력해주세요'
    return
  }

  // 숫자만 허용 (선택사항)
  if (!/^\d+$/.test(frmhsNo.value.trim())) {
    error.value = '농가번호는 숫자만 입력 가능합니다'
    return
  }

  const baseUrl = 'http://kahis.go.kr:8201/gps/svm/actionFrmnhsVhcMv.do'
  currentUrl.value = `${baseUrl}?frmhsNo=${frmhsNo.value.trim()}`
}
</script>

<style scoped>
.farm-query {
  padding: 20px;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.card {
  max-width: 100%;
  margin: 0 auto;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.iframe-container {
  height: calc(100vh - 170px);
  min-height: 500px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  overflow: hidden;
  background: white;
}

iframe {
  width: 100%;
  height: 100%;
}

.input-group {
  max-width: 600px;
  margin: 0 auto;
}

/* 모바일 최적화 */
@media (max-width: 768px) {
  .farm-query {
    padding: 10px;
  }

  .iframe-container {
    height: calc(100vh - 180px);
  }

  .btn-lg {
    padding: 0.5rem 1rem;
  }
}
</style>
